<template>
  <div class="messages-wrapper">
    <div class="content-wrapper">
      <MediaTaggingNavigationPanel />
      <CustomSearch v-if="false" placeholder="Find..." @update:modelValue="keySearch = $event" />
      <div class="scrollable-container">
        <div class="attachment-wrapper">
          <GalleryItem
            v-for="(item) in displayedMediaList"
            :id="`media-attachment_id-${createUniqKey(item.uniqKey)}`"
            :key="item.uniqKey"
            class="attachment-media"
            :attachment="item"
            @changeCheckbox="changeAttachmentCheckbox"
            @exportItem="openExportPopup"
            @updateMedia="updateMedia"
            @openMediaPopup="openMediaPopup"
          />
        </div>
        <SelectedMessagesInfo
          :messages="displayedMediaList"
          :selected-messages-id="selectedAttachmentsIds"
          @updatedActiveStatus="updatedActiveStatus"
          @exportMedia="openExportPopup"
          @selectedFormat="format = $event"
          @pinMarked="pinMarked"
        />
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="spinner">
            Loading...
          </div>
          <div slot="no-more">
            No more media
          </div>
          <div slot="no-results">
            No results
          </div>
        </infinite-loading>
      </div>
    </div>
    <MediaTaggingPanel
      :update-media="updateId"
      @updateMainItem="updateMainItem"
      @openMediaPopup="openMediaPopup"
    />
    <CommonDialog
      ref="progressDialog"
      :show-footer="false"
      :closable="false"
    >
      <h2 class="dialog-message-title">
        Exporting media
      </h2>
      <p class="dialog-create-description" style="display:block; font-size: 14px;">
        Please wait a bit. The media is being exported.
      </p>
      <div class="loader-p" />
    </CommonDialog>
    <SuccessPopup
      ref="successPopup"
      text="A URL will be sent to your email with a download link. Do not share this link."
    />
    <MediaItemPopup
      ref="mediaItemPopup"
      :attachment="currentAttachment"
      :attachment-type="currentAttachmentType"
      :tags-list="currentTagsList"
      :unblurred-link="unblurredLink"
      :gallery-items="galleryItems"
      :current-index="currentIndex"
      @closed="unblurredLink = ''"
      @menuOptionSelect="handleMenuOptionSelect"
      @showOriginContent="showOriginContent"
      @pageChanged="handlePageChanged"
    />
    <MetadataPopup ref="metadataPopup" :file-metadata="fileMetadata" />
  </div>
</template>

<script>
import MediaTaggingNavigationPanel from '@/components/cases/case-messages/media-tags/MediaTaggingNavigationPanel.vue';
import CustomSearch from '@/components/inputs/CustomSearch.vue';
import MediaTaggingPanel from '@/components/cases/case-messages/media-tags/MediaTaggingPanel.vue';
import InfiniteLoading from 'vue-infinite-loading';
import SelectedMessagesInfo from '@/components/selected-messages-info/SelectedMessagesInfo.vue';
import CommonDialog from '@/components/popups/CommonDialog.vue';
import SuccessPopup from '@/components/popups/SuccessPopup.vue';
import streamReader from '@/mixins/streamReader';
import mediaTagging from '@/mixins/mediaTagging';
import GalleryItem from '@/components/cases/case-messages/media/GalleryItem.vue';
import MediaItemPopup from '@/components/popups/MediaItemPopup.vue';
import MetadataPopup from '@/components/popups/MetadataPopup.vue';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'MediaTaggingPinnedTab',
  components: {
    GalleryItem,
    SuccessPopup, CommonDialog,
    SelectedMessagesInfo,
    MediaTaggingPanel,
    CustomSearch,
    MediaTaggingNavigationPanel,
    InfiniteLoading,
    MediaItemPopup,
    MetadataPopup,
  },
  mixins: [streamReader, mediaTagging],
  data() {
    return {
      infiniteId: +new Date(),
      updateId: +new Date(),
      selectedAttachmentsIds: [],
      isCheckedAllMessages: false,
      page: 1,
      pageSize: 10,
      format: '',
      currentAttachment: {},
      currentAttachmentType: '',
      currentTagsList: [],
      unblurredLink: '',
      galleryItems: [],
      currentIndex: 0,
      fileMetadata: null,
    };
  },
  computed: {
    ...mapGetters('mediaTagging', {
      isTaggingActive: 'isTaggingActive',
      taggingItem: 'getTaggingItem',
    })
  },
  watch: {
    keySearch() {
      this.updateMedia();
    },
    displayedMediaList: {
      deep: true,
      handler() {
        if (this.isCheckedAllMessages) {
          this.displayedMediaList.map(message => {
            message.isActive = true;
            if (!this.selectedAttachmentsIds.includes(message.id)) {
              this.selectedAttachmentsIds.push(message.id);
            }
            return message;
          });
        } else {
          this.displayedMediaList.map(message => {
            const messageId = this.selectedAttachmentsIds.find(id => id === message.id);
            message.isActive = !!messageId;
            return message;
          });
        }
      }
    },
    selectedAttachmentsIds: {
      deep: true,
      handler() {
        this.displayedMediaList.forEach(message => {
          message.isActive = this.selectedAttachmentsIds.includes(message.id);
        });
      }
    }
  },
  methods: {
    ...mapActions('mediaTagging', ['setInitialState']),
    updateMainItem() {
      this.getMediaByGalleryId();
    },
    updateMedia() {
      this.page = 1;
      this.displayedMediaList = [];
      this.selectedAttachmentsIds = [];
      this.loadFlag = true;
      this.infiniteId += 1;
      this.updateId += 1;
    },
    async infiniteHandler($state) {
      await this.getListGalleryFiles(
        $state,
        this.clientId,
        {
          page: this.page,
          size: this.pageSize,
          pinnedOnly: true,
          keySearch: this.keySearch
        }
      );
      const hasTaggingItem = this.displayedMediaList.find(item => item.id === this.taggingItem.id);
      if (!hasTaggingItem) {
        this.setTaggingItem(this.displayedMediaList[0]);
      }
    },
    changeAttachmentCheckbox(item) {
      if (item.isActive) {
        if (!this.selectedAttachmentsIds.includes(item.id)) {
          this.selectedAttachmentsIds.push(item.id);
        }
      } else {
        this.selectedAttachmentsIds = this.selectedAttachmentsIds.filter(id => id !== item.id);

        if (this.selectedAttachmentsIds.length === 0) {
          this.isCheckedAllMessages = false;
        }
      }

      const index = this.displayedMediaList.findIndex(message => message.id === item.id);
      if (index !== -1) {
        this.displayedMediaList[index].isActive = item.isActive;
      }
    },
    updatedActiveStatus($event) {
      this.isCheckedAllMessages = $event.isCheckedAllMessages;
      this.selectedAttachmentsIds = $event.selectedMessagesId;
      this.displayedMediaList = $event.messages;

      if (this.isCheckedAllMessages) {
        this.selectedAttachmentsIds = this.displayedMediaList.map(message => message.id);
      } else {
        this.selectedAttachmentsIds = [];
      }
    },
    openExportPopup(data) {
      this.selectedAttachmentsIds = Array.isArray(data) ? data : [data];
      this.exportMedia();
    },
    exportMedia() {
      this.$load(async () => {
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.media.exportGallery(
          this.$route.params.slug,
          this.format || 'csv',
          {galleryIds: this.selectedAttachmentsIds}
        );
        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();
        this.selectedAttachmentsIds = [];

        this.$refs.successPopup.openPopup();
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    async pinMarked(galleryIds) {
      const mediaArrayByIds = [
        ...this.displayedMediaList.filter(item => galleryIds.includes(item.id))
      ];
      const pinnedItems = mediaArrayByIds.filter(item => item.isPinned);

      if (pinnedItems.length === galleryIds.length) {
        await this.unPinGallery(galleryIds);
      } else if (pinnedItems.length > 0 || pinnedItems.length < 1) {
        const resultIdsArray = mediaArrayByIds.filter(item => !item.isPinned).map(item => item.id);
        await this.pinGallery(resultIdsArray);
      }

      this.updateMedia();
    },
    openMediaPopup(itemId) {
      const allGalleryItems = [...this.displayedMediaList];
      const currentIndex = allGalleryItems.findIndex(item => item.id === itemId);
      if (currentIndex !== -1) {
        this.galleryItems = allGalleryItems;
        this.currentIndex = currentIndex;
        this.currentAttachment = allGalleryItems[currentIndex];

        this.currentAttachmentType = this.currentAttachment.type
          ? this.currentAttachment.type.split('/')[0].toLowerCase()
          : this.getFileType(this.currentAttachment.name);
        this.currentTagsList = this.currentAttachment.tags || [];

        this.$refs.mediaItemPopup.openPopups();
      }
    },

    getFileType(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();

      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'heic', 'heif'];
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv'];

      if (imageExtensions.includes(extension)) {
        return 'image';
      } else if (videoExtensions.includes(extension)) {
        return 'video';
      } else {
        return 'other';
      }
    },

    async handleMenuOptionSelect(optionName) {
      switch (optionName.toLocaleLowerCase()) {
        case 'export':
          this.openExportPopup(this.currentAttachment.id);
          break;
        case 'mark priority':
        case 'remove from priorities':
          if (!this.currentAttachment.isPinned) {
            await this.pinGallery([this.currentAttachment.id]);
          } else {
            await this.unPinGallery([this.currentAttachment.id]);
          }
          this.$refs.mediaItemPopup.closePopups();
          this.updateMedia();
          break;
        case 'redact media':
        case 'unredact media':
          if (!this.currentAttachment.isBlured) {
            this.blurGallery(this.currentAttachment.id).then(() => {
              this.updateAttachmentInPopup();
            });
          } else {
            this.unBlurGallery(this.currentAttachment.id).then(() => {
              this.updateAttachmentInPopup();
            });
          }
          this.updateMedia();
          break;
        case 'show meta':
          this.openMetadataPopup();
          this.$refs.mediaItemPopup.closePopups();
          break;
        case 'view details':
          this.gotoTagging();
          this.$refs.mediaItemPopup.closePopups();
          break;
      }
    },

    updateAttachmentInPopup() {
      this.$load(async () => {
        const response = await this.$api.media.getGalleryById(
          this.caseId,
          this.clientId,
          this.currentAttachment.id
        );
        this.currentAttachment = response.data.body;
        this.currentTagsList = this.currentAttachment.tags || [];

        const index = this.galleryItems.findIndex(item => item.id === this.currentAttachment.id);
        if (index !== -1) {
          this.$set(this.galleryItems, index, this.currentAttachment);
        }
      }, (error) => {
        this.handleResponseError(error);
      });
    },

    async showOriginContent(galleryId) {
      await this.showBluredGallery(galleryId);
    },

    handlePageChanged(data) {
      this.currentIndex = data.index;
      this.currentAttachment = this.galleryItems[data.index];
      this.currentTagsList = this.currentAttachment.tags || [];
      this.currentAttachmentType = this.currentAttachment.type
        ? this.currentAttachment.type.split('/')[0].toLowerCase()
        : this.getFileType(this.currentAttachment.name);
    },

    openMetadataPopup() {
      this.$load(async () => {
        const response = await this.$api.media.getGalleryData({
          caseId: this.caseId,
          galleryId: this.currentAttachment.id
        });
        this.fileMetadata = response.data.body;
        this.$refs.metadataPopup.openPopups();
      }, (error) => {
        this.handleResponseError(error);
      });
    },

    gotoTagging() {
      if (this.isTaggingActive) {
        this.setTaggingItem(this.currentAttachment);
      } else {
        this.setInitialState({
          caseId: this.caseId,
          clientId: this.clientId,
          taggingItem: this.currentAttachment,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.messages-wrapper {
  display: flex;
  margin: 25px 60px 0 40px;
  max-width: 90vw;

  .content-wrapper {
    position: relative;
    padding: 50px 0 0;
    min-width: 600px;
    width: 100%;

    .scrollable-container {
      height: 90vh;
      overflow-y: auto;
      scrollbar-color: var(--background-color) transparent;
      scrollbar-width: thin;
      border-top: 1px solid var(--case-btn-border-color);
      margin-top: 15px;

      .attachment-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 25px;
        margin: 20px 0 50px 0;
      }
    }
  }


  .loader-p {
    width: 50px;
    height: 50px;
    position: relative;
    margin: 20px 40px 20px 0;
  }
}
</style>
